// extracted by mini-css-extract-plugin
export default {"timeError":"confirmPhoneForm-module__timeError__xPeIE"};